import { useTranslation } from 'react-i18next';

import { useAlertDialog } from '@/components/ui/alert-dialog';
import { useAbility } from '@/hooks/ability';
import api from '@/services/api/api';
import PermissionFormData from '@/types/Permission/PermissionFormData';
import { useMutation } from '@tanstack/react-query';

export const useStorePermissionMutation = () => {
  const { alert } = useAlertDialog();
  const { t } = useTranslation();

  const ability = useAbility();

  return useMutation({
    mutationFn: async (data: PermissionFormData) => {
      if (!ability.can('admin.permission.store', '')) {
        return alert({
          title: t('no-permission'),
          description: t('you-dont-have-permission-to-do-that'),
          type: 'error',
        });
      }
      const response = await api.post('admin/permission', data);
      return response.data;
    },
    mutationKey: ['storePermission'],
  });
};
